<template>
    <div class="table-container">
        <el-table
            :data="applications"
            v-loading="isLoading"
            size="small"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    {{props.row.description||'-暂无描述-'}}
                </template>
            </el-table-column>
            <el-table-column
                prop="category"
                label="需求类型"
                width="140"
            ></el-table-column>
            <el-table-column
                prop="domain"
                label="领域"
                width="140"
            ></el-table-column>
            <el-table-column
                prop="title"
                label="名称"
                show-overflow-tooltip
                min-width="180"
            >
            </el-table-column>
            <el-table-column
                prop="name"
                label="申请人"
                width="120"
            ></el-table-column>
            <el-table-column
                prop="phone"
                label="联系电话"
                width="120"
            ></el-table-column>
            <el-table-column
                prop="company"
                label="公司"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="is_handled"
                label="已处理"
                width="90"
                :formatter="boolFormatter"
            ></el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="140"
            >
                <template slot-scope="scope">
                    <el-button disabled type="text" size="small" v-if="scope.row.is_handled">已处理</el-button>
                    <ox-safe-button
                        v-else
                        @confirm="handle(scope.row)"
                        type="text"
                        size="small"
                        message="确认要将该申请的状态改为已处理码？"
                    >已处理</ox-safe-button>
                    <el-divider direction="vertical"></el-divider>
                    <ox-safe-button
                        @confirm="remove(scope.row)"
                        type="text"
                        size="small"
                    >删除</ox-safe-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="onPageChange"
                :page-size="pagination.size"
                :current-page="pagination.current"
                :total="pagination.total"
            >
            </el-pagination>
        </div>

    </div>
</template>

<script>
import { pageMixin, fmtMixin } from "@/ox/Mixins";
import OxSafeButton from '@/ox/components/OxSafeButton';

const states = {
    '所有': null,
    '未处理': false,
    '已处理': true
}

export default {
    name: "ApplicationTable",
    mixins: [pageMixin, fmtMixin],
    components:{
        OxSafeButton
    },
    data: function() {
        return {
            page: 1,
            isLoading: false,
            applications: []
        };
    },

    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.isLoading = true;
            const currentPage = page || this.page;
            const query = new window.BaaS.Query();
            const {filter} = this.$parent;
            const state = states[filter.state];
            if(state!==null){
                if(state){
                    query.compare('is_handled', '=' ,true)
                }else{
                    query.compare('is_handled', '!=' ,true)
                }
            }
            if(filter.keyword){
                query.contains(filter.column, filter.keyword.trim())
            }
            if(filter.category){
                query.compare('category','=', filter.category)
            }
            if(filter.domain){
                query.compare('domain','=', filter.domain)
            }
            this.$ox
                .service("demand_application")
                .find(query, {
                    page: currentPage,
                    withCount: true,
                    orderBy: ["-created_at"]
                })
                .then(res => {
                    this.isLoading = false;
                    this.pagination.size = res.meta.limit;
                    this.pagination.total = res.meta.total_count;
                    this.pagination.current = currentPage;
                    this.page = currentPage;
                    this.applications = res.objects;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        onPageChange(page) {
            this.loadData(page);
        },
        handle(row) {
            this.$ox.service('demand_application').update(row.id,{
                is_handled: true
            }).then(()=>{
                this.applications = this.applications.map(app => {
                    if(app.id === row.id){
                        app.is_handled = true
                    }
                    return app;
                })
                this.$notify.success({
                  title: '操作成功',
                  message: `申请“${row.title}”已处理`
                });
                this.$ox.eventBus.$emit('application-handled');
            })
        },
        remove(row){
            this.$ox.service('demand_application').delete(row.id).then(()=>{
                this.applications = this.applications.filter(application=>application.id!==row.id)
                this.$notify.success({
                  title: '操作成功',
                  message: `申请“${row.title}”已删除`
                });
                this.$ox.eventBus.$emit('application-handled');
            })
        }
    }
};
</script>

<style scoped>
</style>
